<template>
  <div class="debug">
    <section>
      <camera
        :nodeData="nodeData"
        :lf="lf"
        :socketResponse="socketResponse"
        @onClose="handleClose"
        @capturePic="capturePic"
      />
    </section>
  </div>
</template>
<script>
import camera from "./camera";
// import { toTurboData } from '../../Util/AdpterForTurbo';
export default {
  name: "debug",
  components: {
    camera,
  },
  props: {
    nodeData: Object,
    socketResponse: Object,
    graphData: Object,
    lf: Object,
  },

  mounted() {
    console.log(this.nodeData.properties, "pro132321perties");
  },
  methods: {
    capturePic(record, callback) {
      this.$emit("capturePic", record, callback);
    },
    handleClose(record, callback) {
      // 数据转化为Turbo识别的数据结构
      this.$emit(
        "setPropertiesFinish",
        { id: record.id, formData: record.formData },
        callback
      );
    },
  },
};
</script>
<style></style>
